import React from 'react';
import PropTypes from 'prop-types';
import { formatMessageTime } from '../../../utils/MessageTime';

export function MessageTimestamp({ value }) {
  const { label, full, dateTime } = formatMessageTime(value);
  return dateTime ? (
    <time dateTime={dateTime} title={full} aria-label={full}>{label}</time>
  ) : (
    <span title={full} aria-label={full}>{label}</span>
  );
}

MessageTimestamp.propTypes = { value: PropTypes.string };
